// Font
import { Global, css } from "@emotion/react";
import { BasicFontKR } from "./font";
export const Font = {
  ko: "Noto sans KR",
  en: "Noto sans",
};

const baseStyle = css`
  html,
  body,
  p,
  ol,
  ul,
  li,
  dl,
  dt,
  dd,
  blockquote,
  figure,
  fieldset,
  legend,
  textarea,
  pre,
  iframe,
  hr,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  ul,
  li,
  ol {
    list-style: none;
  }
  button,
  input,
  select {
    margin: 0;
    padding: 0;
  }
  html {
    box-sizing: border-box;
  }

  * {
    ::-webkit-scrollbar {
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 6px;
      background-color: rgba(255, 255, 255, 0.4);
    }
    ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 6px;
    }
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  img,
  video {
    height: auto;
    max-width: 100%;
  }
  iframe {
    border: 0;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  td,
  th {
    padding: 0;
  }

  * {
    font-family: ${BasicFontKR}, sans-serif;
  }
  @media (max-width: 600px) {
    * {
      font-size: 14px;
    }
  }
`;

const GlobalStyle = () => <Global styles={baseStyle} />;

export default GlobalStyle;
